const convertHTMLObjToArrayForKpp = (htmlObj) => {
  return Object.entries(htmlObj).map(([key, html]) => {
    return { id: key, ...parseHTMLStringForKpp(html) };
  });
}

const parseHTMLStringForKpp = (htmlString) => {
  const name = (htmlString.match(/<[^>]+data-id="name"[^>]*>([^<]+)<\/[^>]+>/) || [])[1] ?? '';
  const description = (htmlString.match(/<[^>]+data-id="description"[^>]*>\s*([^<]+)/s) || [])[1]?.trim() ?? '';
  const rating = (htmlString.match(/<[^>]+data-id="ratingValue"[^>]*>([^<]+)<\/[^>]+>/) || [])[1] ?? '';
  const reviewCount = (htmlString.match(/<[^>]+data-id="reviewCount"[^>]*>([^<]+)<\/[^>]+>/) || [])[1] ?? '';
  const address = (htmlString.match(/<[^>]+data-id="address"[^>]*>([^<]+)<\/[^>]+>/) || [])[1] ?? '';
  const image = (htmlString.match(/<[^>]+srcset="([^"]+)"[^>]*>/) || [])[1] ?? '';

  return { name, description, rating, reviewCount, address, image };						
}

const generateJsonLdForKpp = (kppData, site, placeName = '') => {
  return kppData.map(item => {
    const aggregateRating = item.rating ? {
      "@type": "AggregateRating",
      ratingValue: item.rating,
      reviewCount: item.reviewCount
    } : undefined;

    const address = {
      "@type": "PostalAddress",
      addressLocality: item.address || placeName,
      addressCountry: "US"
    };

    const logo = item.image ? {
      "@type": "ImageObject",
      contentUrl: item.image
    } : undefined;
    
    return {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      additionalType: site === 'demolition' ? "https://schema.org/HomeAndConstructionBusiness" : "https://schema.org/WasteManagement",
      name: item.name,
      description: item.description,
      ...(aggregateRating && { aggregateRating }),
      address,
      ...(logo && { logo })
    };
  });
};

const formatBookingJson = (data) => {
  let newFormData = data
  if (typeof data === 'string') {
    try {
      newFormData = JSON.parse(data);
    } catch (error) {
      console.error('Error parsing JSON:', error);
    }
  }
  const initialValues = [
    { key: 'wasteType', value: [+newFormData.wasteType] },
    { key: 'deliveryAddress', value: (newFormData.odf_street && newFormData.odf_street2) ? newFormData.odf_street + ', ' + newFormData.odf_street2 : ''},
    { key: 'fullFormData', value: newFormData},
  ]
  localStorage.setItem('onlineBookingData',JSON.stringify({ placeId: null, baseServiceId: "62a9f2cd61706a135071a7e3", skip: 0, limit: 21, initialValues: initialValues, finalDataForBooking: null }))
  return newFormData;
}

// Build breadcrumb schema Json-LD
const buildBreadcrumbSchema = (page) => {
  const breadcrumb = page.breadcrumb || [];

  // Only include links with both url and label
  const validLinks = breadcrumb.filter(
    link => link?.url && link?.label
  );

  if (validLinks.length === 0) return null;

  const items = validLinks.map((link, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: link.label,
    item: link.url
  }));

  return {
    "@type": "BreadcrumbList",
    itemListElement: items
  };
};

// Build profiles schema Json-LD
const buildWasteManagementServiceSchema = (page, reviewsData = []) => {
  if (!page?.profile) return null;

  const profile = page.profile;

  const schema = {
    "@type": "HomeAndConstructionBusiness",
    "@id": `${page.env?.domain || ''}/${page.url}#business`,
    name: profile.name,
    url: `${page.env?.domain || ''}/${page.url}`,
  };

  // Phone
  if (profile.phone) {
    schema.telephone = profile.phone;
  }

  const SERVICE_PRIORITY = [
        'Dumpster Rental',
        'Junk Removal',
        'Commercial Trash Service',
    ];

  const getPrimaryService = (page) => {
      const services = page.services?.[0] || [];

      const serviceNames = services.map(s => s.name);
      return SERVICE_PRIORITY.find(p => serviceNames.includes(p)) || 'Dumpster Rental';
  };

  const getSeoCities = (page, limit = 3) => {
        const cities = page.areas?.flatMap(area => area.places || []) || [];
        
        return cities.slice(0, limit).map(city => city.split(',')[0]);
    };

  // Description
  if (profile.name && page.services?.length > 0 && page.areas?.length > 0) {
    const service = getPrimaryService(page);
    const cities = getSeoCities(page).join(', ');

    switch (service) {
      case 'Junk Removal':
        schema.description = `Get affordable cleanouts and junk pickup from ${profile.name}. Full-service junk removal in ${cities} and nearby.`;
        break;

      case 'Commercial Trash Service':
        schema.description = `Get affordable commercial trash pickup from ${profile.name} in ${cities} and nearby. Get a quote and save on monthly rates.`;
        break;

      case 'Dumpster Rental':
      default:
        schema.description = `Get dumpster rental pricing and availability for ${profile.name}. Easy online booking & same day/next day delivery to ${cities} and nearby.`;
        break;
    }
  }

  // Logo url
  if (profile.logo?.path) {
    schema.image = profile.logo.path;
  }

  // Address
  if (profile.add_c && profile.add_av && profile.zip) {
    schema.address = {
      "@type": "PostalAddress",
      addressLocality: profile.add_c,
      addressRegion: profile.add_av,
      postalCode: profile.zip,
      addressCountry: "US",
    };

    if (!profile.hide_address && profile.address) {
      schema.address.streetAddress = profile.address;
    }
  }

  // Area Served 
  if (page.areas?.length > 0) {
    const cities = [];

    page.areas.forEach(area => {
      area.places?.forEach(place => {
        const city = place.split(',')[0]?.trim();
        if (city && cities.length < 10) {
          cities.push({
            "@type": "City",
            name: city,
          });
        }
      });
    });

    if (cities.length > 0) {
      schema.areaServed = cities;
    }
  } 
  

  // Offer Catalog (Dumpster Services)
  if (page.serviceSeekerData?.defaultServices?.length > 0) {

    const buildServiceDescription = (service) => {
      const weightDetail = service.details?.find(d => d.text1?.includes('ton'));
      const dayDetail = service.details?.find(d => d.text1?.includes('day'));

      const weightTerm = weightDetail?.text3 || weightDetail?.text1?.split('. <br>')[0];
      const dayTerm = dayDetail?.text3 || dayDetail?.text1?.split('. <br>')[0];

      if (!weightTerm || !dayTerm) return '';

      return `Includes up to ${dayTerm.replace('included', '').trim()} and ${weightTerm.replace('included', '').trim()} of waste`;
    };


    schema.hasOfferCatalog = {
      "@type": "OfferCatalog",
      name: "Waste Management Services",
      itemListElement: [
        {
          "@type": "OfferCatalog",
          name: "Dumpster Rental",
          itemListElement: page.serviceSeekerData.defaultServices.map(service => ({
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: service.title + ' Rental',
              description: buildServiceDescription(service)
            },
            priceSpecification: {
              "@type": "PriceSpecification",
              price: service.price,
              priceCurrency: "USD",
              description: "Starting at price"
            }
          }))
        }
      ]
    };
  }


  // Aggregate Rating
  if (reviewsData?.ratingValue && reviewsData?.reviewCount) {
    schema.aggregateRating = {
      "@type": "AggregateRating",
      ratingValue: reviewsData.ratingValue,
      reviewCount: reviewsData.reviewCount,
      bestRating: "5",
      worstRating: "1",
    };
  }

  // Reviews (top N)
  if (reviewsData?.reviews?.length > 0) {
    schema.review = reviewsData.reviews.slice(0, 5);
  }

  return schema;
};



const manualGoogleEvents = (eventName) => {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: eventName
    });
  }
}

const formatData = (data) => {
  let address = data.find(element => element.key === 'fullFormData').value
  if(address) {
    address = JSON.parse(address)
    let addressObj = {}
    address.forEach(e => addressObj[e[0]] = e[1])
    const wasteType = data.find(element => element.key === 'wasteType').value
    const dumpsterSize = data.find(e => e.key === 'dumpsterSize')?.value
    const obj = {
      "odf_country": addressObj.country,
      "odf_locality": addressObj.locality,
      "odf_place_id": addressObj.place_id,
      "odf_postal_code": addressObj.postal_code,
      "odf_state": addressObj.state,
      "odf_street": addressObj.street,
      "odf_street2": addressObj.street2,
      "wasteType": wasteType,
    }
    if (dumpsterSize) {
      obj.dumpsterSize = dumpsterSize;
    }
    return obj;
  }
}

const getFormDataForStorage = () => {
  let obj = {};
  if(typeof window !== 'undefined'){ 
    const localData = JSON.parse(localStorage.getItem('onlineBookingData'));
    if(localData){
      let populatedData = {};
      if (localData.finalDataForBooking) {
        populatedData = formatData(localData.finalDataForBooking);
      } else {
        populatedData = localData.initialValues?.find(data => data.key === 'fullFormData')?.value
      }
      if (populatedData?.wasteType && populatedData?.odf_postal_code) {
        const wasteTypeValue = Array.isArray(populatedData.wasteType) ? populatedData.wasteType[0] : populatedData.wasteType;
        obj.wasteType = wasteTypeValue;
        delete populatedData.wasteType;
        delete populatedData.dumpsterSize;
        obj.addressData = { ...populatedData };
      }
    }
  }
  return obj;
}

const getInitialFormValues = () => {
  const localData = getFormDataForStorage();
  if (localData?.addressData && localData?.wasteType) {
    const allData = {
      ...localData.addressData,
      wasteType: localData.wasteType
    };
    const keyValueArray = Object.entries(allData).map(([key, value]) => ({
      key,
      value
    }));
    return keyValueArray;
  }
  return [];
}

const trackProCardsViews = (eventPrefix, className, startCounter = 0, customerView, sponsored) => {
  if (!window.dataLayer) {
    console.error("dataLayer is not available.");
    return;
  }

  const elements = document.getElementsByClassName(className);
  if (!elements || elements.length === 0) {
    return;
  }
  const viewedServiceIds = new Set(); // track each unique service card
  const viewedProIds = new Set();     // track unique pros for customer views

  if (startCounter > 0) {
    [...elements].slice(0, startCounter).forEach(el => {
      const proId = el.dataset.proid;
      if (proId) viewedProIds.add(proId);
    });
  }

  let counter = startCounter;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const proId = el.dataset.proid;
          const serviceId = el.dataset.serviceid;
          // main event — fire once per serviceId (each card)
          if (!viewedServiceIds.has(serviceId)) {
            viewedServiceIds.add(serviceId);
            counter++;

            const eventName = eventPrefix + counter;
            const eventData = {
              event: eventName,
              proid: proId,
            };
            eventData[eventName] = proId;

            window.dataLayer.push(eventData);
          }

          // customer view — fire once per proId
          if (customerView && !viewedProIds.has(proId)) {
            viewedProIds.add(proId);
            const foundIndex = viewedProIds.size;
            const eventGtaName = (sponsored ? "sponsoredProServiceVisible" : "proServiceVisible") + foundIndex;
            const eventGtaData = {
              event: eventGtaName,
              proid: proId,
            };
            eventGtaData[eventGtaName] = proId;

            window.dataLayer.push(eventGtaData);
          }

          obs.unobserve(el); // stop tracking once it has been seen
        }
      });
    },
    {
      root: null,
      threshold: 0.3, // 30% visible to trigger
    }
  );

  const elementsToProcess = [...elements].slice(startCounter);
  elementsToProcess.forEach(el => observer.observe(el));
}

const trackSimpleEvent = (eventName, proId) => {
  window.dataLayer = window.dataLayer || [];
  
  window.dataLayer.push({
    event: eventName,
    proid: proId,
    timestamp: Date.now(),
  });
};


const trackProCardsViewsOnViewport = (eventPrefix, className, startCounter = 0) => {
  if (!window.dataLayer) {
    console.error("dataLayer is not available.");
    return;
  }

  const elements = document.getElementsByClassName(className);
  if (!elements?.length) return;

  const viewed = new Set();
  let counter = startCounter;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const proId = el.dataset.proid;
          if (!viewed.has(proId)) {
            viewed.add(proId);
            counter++;

            const eventName = eventPrefix + counter;
            const eventData = {
              event: eventName,
              proid: proId,
            };
            eventData[eventName] = proId;

            window.dataLayer.push(eventData);
          }

          obs.unobserve(el);
        }
      });
    },
    {
      root: null,
      threshold: 0.3, // 30% visible
    }
  );

  const elementsToProcess = [...elements].slice(startCounter)
  if (elementsToProcess?.length > 0) {
    elementsToProcess.forEach(el => observer.observe(el));
  }
};

const trackBookingSubmission = (proId) => {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: 'bookingSubmission',
      proid: proId,
      'bookingSubmission': proId
    });
  }
}

const createAddressEvent = async (addressObject, proId) => {
  try {
    if (process.env.GATSBY_EVENTS_API_URL) {
      const source = window.location.origin;
      const url = window.location.href;
      let sessionId = localStorage.getItem('sessionId');
      if (!sessionId) {
        const auxCode = Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2)
        localStorage.setItem('sessionId', auxCode)
        sessionId = auxCode;
      }
      const event = {
        eventType: "SC",
        eventDescription: !addressObject.hasNoCity ? "Address Selected" : "No city selected",
        eventData: {
          source,
          sessionId,
          url,
          ...addressObject,
        }
      }
      if (proId) {
        event.proId = proId;
      }

      const response = await fetch(
        `${process.env.GATSBY_EVENTS_API_URL}/events`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(event),
        }
      );
      return await response.json();
    }
    return;
  } catch (error) {
    console.error('Error creating address event:', error);
  }
}

module.exports = { convertHTMLObjToArrayForKpp, generateJsonLdForKpp, formatBookingJson, manualGoogleEvents, formatData, getFormDataForStorage, getInitialFormValues, trackProCardsViews, trackSimpleEvent, trackBookingSubmission, createAddressEvent, trackProCardsViewsOnViewport, buildBreadcrumbSchema, buildWasteManagementServiceSchema };